import * as React from "react";
export function SvgDataCatalogLineageDashboard(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <path
        d="M18 5H5c-.5 0-1 .4-1 1v13c0 .5.5 1 1 1h13c.6 0 1-.5 1-1V6c0-.6-.5-1-1-1zm0 7h-6V6h6v6zm-7-6v6H5V6h6zm-6 7h6v6H5v-6zm7 6v-6h6v6h-6z"
        fill="#666"
      />
    </svg>
  );
}
